import React from "react";
import BulkAdjustmentModal from "./BulkAdjustmentModal";

const BulkAllowanceModal = (props) => <BulkAdjustmentModal kind="allowance" {...props} />;

export default BulkAllowanceModal;
